module.exports = __webpack_public_path__ + "img/money2.3c5c7abc.jpg";